import { render, staticRenderFns } from "./QuestionsSegment1.vue?vue&type=template&id=67454362&scoped=true&"
import script from "./QuestionsSegment1.vue?vue&type=script&lang=js&"
export * from "./QuestionsSegment1.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsSegment1.vue?vue&type=style&index=0&id=67454362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67454362",
  null
  
)

export default component.exports